import { render, staticRenderFns } from "./Create_v2.vue?vue&type=template&id=13f1da47&"
import script from "./Create_v2.vue?vue&type=script&lang=js&"
export * from "./Create_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports